// extracted by mini-css-extract-plugin
export default {"loading":"T1PEDYso224efj98hUw9","loaded":"HydBuzzegFMoqMkrptg7","image":"Pq0tg32DAJ33TmIQMvMs"};